<template>
  <div
    class="rr-loader"
    :class="classes"
  >
    <div v-if="overlay" class="rr-loader__overlay"></div>
    <div class="rr-loader__content">
      <div
        class="rr-loader__icon"
        :class="{'rr-loader__icon_simple' : this.simpleIcon}"
      >
        <svg xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.728 1.774C10.728 1.07 11.298.5 12 .5a11.463 11.463 0 018.132 3.37 11.48 11.48 0 012.464 3.654c.6 1.418.903 2.926.903 4.477 0 1.55-.303 3.059-.903 4.477-.578 1.371-1.41 2.6-2.464 3.655A11.48 11.48 0 0112 23.503a11.464 11.464 0 01-8.132-3.37A11.463 11.463 0 01.5 12a1.273 1.273 0 112.547 0 8.94 8.94 0 002.623 6.333 8.903 8.903 0 006.331 2.621 8.941 8.941 0 006.333-2.623 8.904 8.904 0 002.621-6.33c0-1.211-.236-2.382-.704-3.487a8.965 8.965 0 00-1.919-2.847 8.904 8.904 0 00-6.33-2.621c-.705 0-1.274-.57-1.274-1.273z"/></svg>
      </div>
      <div class="rr-loader__title" v-if="title" v-html="title"></div>
      <div class="rr-loader__text" v-if="text" v-html="text"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    /**
     * Заголовок
     */
    title: String,
    /**
     * Текст
     */
    text: String,
    /**
     * В виде оверлея
     */
    overlay: {
      type: Boolean,
      default: false,
    },
    /**
     * Внешний вид
     */
    variant: {
      type: String,
      default: 'light',
      validator(value) {
        return ['dark', 'light'].indexOf(value) !== -1;
      },
    },
    /**
     * Отключить градиент для иконки.<br>
     * Наследует цвет текста.
     */
    simpleIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'rr-loader_overlay': this.overlay,
        'rr-loader_dark': this.variant === 'dark',
        'rr-loader_light': this.variant === 'light',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Loader";
</style>
